import styled from 'styled-components';

import { IFlat } from '../../common/model/flat.model';

type Props = {
  flat: IFlat;
  className?: string;
};

const Location: React.FC<Props> = ({ flat, className }) => {
  return (
    <div
      className={className}
    >{`${flat.zone}, ${flat.city}, ${flat.county}`}</div>
  );
};

export default styled(Location)`
  font-weight: 600;
  font-size: 14px;
  line-height: 30px;
`;
